'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002497 from "./presto.-Presto-Router$$anon$97.js";
import * as $j_presto$002e$002dSign$002dDocument$002dPage$0024 from "./presto.-Sign-Document-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$96() {
  this.bpX = null;
  this.bpP = null;
  this.bpQ = false;
  this.bpY = null;
  this.bpZ = false;
  this.bq2 = null;
  this.bpV = null;
  this.bpW = false;
  this.bpR = null;
  this.bpS = false;
  this.bpT = null;
  this.bpU = false;
  this.bq0 = false;
  this.bq1 = false;
  this.bpX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bq2 = "SignDocumentPage";
}
export { $c_Lpresto_PrestoRouter$$anon$96 as $c_Lpresto_PrestoRouter$$anon$96 };
$p = $c_Lpresto_PrestoRouter$$anon$96.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$96;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$96() {
}
export { $h_Lpresto_PrestoRouter$$anon$96 as $h_Lpresto_PrestoRouter$$anon$96 };
$h_Lpresto_PrestoRouter$$anon$96.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bpX;
});
$p.L = (function() {
  if ((!this.bpQ)) {
    this.bpP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bpQ = true;
  }
  return this.bpP;
});
$p.O = (function() {
  if ((!this.bpZ)) {
    this.bpY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bpZ = true;
  }
  return this.bpY;
});
$p.E = (function() {
  return this.bq2;
});
$p.t = (function() {
  if ((!this.bpW)) {
    this.bpV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bpW = true;
  }
  return this.bpV;
});
$p.M = (function() {
  if ((!this.bpS)) {
    this.bpR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bpS = true;
  }
  return this.bpR;
});
$p.Q = (function() {
  if ((!this.bpU)) {
    this.bpT = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002497.$c_Lpresto_PrestoRouter$$anon$97();
    this.bpU = true;
  }
  return this.bpT;
});
$p.w = (function() {
  if ((!this.bq1)) {
    this.bq0 = false;
    this.bq1 = true;
  }
  return this.bq0;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee597) => ((p) => \u03b4scrutinee597))($j_presto$002e$002dSign$002dDocument$002dPage$0024.$m_Lpresto_SignDocumentPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$96 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$96, "presto.PrestoRouter$$anon$96", ({
  P5: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$96 as $d_Lpresto_PrestoRouter$$anon$96 };
//# sourceMappingURL=presto.-Presto-Router$$anon$96.js.map
